// Import React and Hooks
import React from 'react'
// Import Components
import FloatImg from './FloatImg'
import ShareButton from './ShareButton'
import DownloadButton from './DownloadButton'
import BeerMask from './BeerMask'



// Modal offering Prop
interface modallOfferingProp {
  additionalClass?:string,
  dataModalOffering: {
    id:string,
    idOffering:number,
    isVisible:boolean,
    hasClose:boolean,
    name:string,
    age:string,
    dedicatedText:string,
    dedicatedBy:string,
    photo:string,
    shareBtn:boolean,
    downloadBtn:boolean
  }
}

const ModalOffering = ( { additionalClass, dataModalOffering }:modallOfferingProp ) => {



  // Destructuring
  const { idOffering, name, age, dedicatedText, dedicatedBy, photo, shareBtn, downloadBtn } = dataModalOffering
   
  return (
    <section className={`modalOffering ${ additionalClass ? additionalClass : ''}`}>
      <FloatImg
          additionalClass={`img1CutterImage`}
          alt="Arreglo floral"
          speed={ 0.013 }
          revert={ true }
          src={`${window.assetsURl}/imgs/shapes/cutterImageFlota.png`} />
      <FloatImg
          additionalClass={`img2CutterImage`}
          alt="Arreglo floral"
          speed={ 0.013 }
          revert={ true }
          src={`${window.assetsURl}/imgs/shapes/cutterImageFlota.png`} />
      <FloatImg
        additionalClass={`flowersModal1`}
        alt="Arreglo floral"
        speed={ 0.013 }
        revert={ true }
        src={`${window.assetsURl}/imgs/shapes/flower-arrangement-6.svg`} />
      <FloatImg
        additionalClass={`flowersModal2`}
        alt="Arreglo floral"
        speed={ 0.008 }
        src={`${window.assetsURl}/imgs/shapes/flower-arrangement-7.svg`} />
      <div className="modalOffering__container">
        <div className="modalOffering__box">
          { name && (
            <h2 className="modalOffering__name mb10 mbM15">
              { name }
            </h2>
          ) }
          { age && (
            <h3 className="modalOffering__age mb25 mbM20">
              { age }
            </h3>
          ) }
          { dedicatedText && (
            <p className="modalOffering__text hiddenUpTablet mb25 mbM20">
              { dedicatedText }
            </p>
          ) }
          { dedicatedBy && (
            <p className="modalOffering__who mb25 mbM25 hiddenUpTablet">
              Dedicado por: { dedicatedBy }
            </p>
          ) }
          { downloadBtn && (
            <div className="w100 taC mb15 wMA mrM5 mlM5 mbM10">
              <DownloadButton
                text="DESCARGAR LATA" />
            </div>
          ) }
          { shareBtn && (
            <div className="w100 taC wMA mrM5 mlM5 mbM10">
              <ShareButton
                text="COMPARTIR"
                id={ idOffering } />
            </div>
          ) }
        </div>
        <div className="modalOffering__box">
          <BeerMask fileImg={ photo } name={ name } />
        </div>
        <div className="modalOffering__box">
          { dedicatedText && (
            <p className="modalOffering__text mb25 mbM20">
              { dedicatedText }
            </p>
          ) }
          { dedicatedBy && (
            <p className="modalOffering__who">
              Dedicado por: { dedicatedBy }
            </p>
          ) }
        </div>
      </div>
    </section>
  )
}



export default ModalOffering
